import { GetMcaEstimatedScheduleResponse } from '@iwoca/lapi-client/edge';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import messages from './RBLLoanSummary.messages';
import { WithdrawalSummary } from './WithdrawalSummary';
import { FormalOffer } from '../../../../MyOffers.types';
import styles from '../../../flexiApprovedView/loanSummary/LoanSummary.module.css';

type TRBLLoanSummaryProps = {
    selectedOffer: FormalOffer | null;
    schedule: NonNullable<GetMcaEstimatedScheduleResponse> | undefined | null;
    scheduleLoading: boolean;
    drawdownAmount: number;
};
export const RBLLoanSummary = ({
    selectedOffer,
    schedule,
    scheduleLoading,
    drawdownAmount
}: TRBLLoanSummaryProps) => {
    const greyedTextClassName = !selectedOffer && styles.greyText;

    return (
        <div className={classNames(styles.loanSummary)}>
            <div
                className={classNames(
                    styles.loanSummaryTitle,
                    greyedTextClassName
                )}
            >
                <FormattedMessage {...messages.loanSummaryTitle} />
            </div>

            {schedule && (
                <WithdrawalSummary
                    schedule={schedule!}
                    loading={scheduleLoading}
                    drawdownAmount={drawdownAmount}
                />
            )}
        </div>
    );
};
